module.exports = __webpack_public_path__ + "a69b6c6d2c0b977c75e878649caf63ae.pdf";